import React from 'react';

import Authorization from '@appComponents/Authorization';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {CLIENT_PACKAGE_GEO_RESTRICTION} from '@constants/resources';
import * as CONSTANT from '@constants/variables';
import {getTerritoriesWithTooltip} from '@utils/countryHelpers';
import {IconWithTooltip} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';

import {renderUsages} from '../../utils/clientGeoRestrictionsHelper';

export const rowRenderer = (column, row, { clientId, clientPackageId, data, history }) => {
    switch (column) {
        case 'id':
            return (
                <LinkWithAuthorization
                    resources={CLIENT_PACKAGE_GEO_RESTRICTION}
                    privileges={CONSTANT.SECURITY_PRIVILEGES_UPDATE}
                    link={{
                        name: 'clients.packages.geoRestrictions.edit',
                        params: {
                            id: clientId,
                            packagesId: clientPackageId,
                            geoRestrictionId: row.id,
                        },
                    }}
                >
                    {row[column]}
                </LinkWithAuthorization>
            );
        case 'usages':
            return renderUsages(row[column]);
        case 'countries':
            return getTerritoriesWithTooltip(row, data.mappedIsoCodes);
        case 'notes':
            return row[column];
        case 'actions': {
            return (
                <Authorization
                    resources={CLIENT_PACKAGE_GEO_RESTRICTION}
                    privileges={CONSTANT.SECURITY_PRIVILEGES_UPDATE}
                >
                    <div className='actions-list-icon'>
                        <IconWithTooltip
                            iconProps={{
                                size: 'large',
                                className: '--withPointer',
                                corner: 'top right',
                            }}
                            name='edit'
                            onClick={() => {
                                history.push(getLink('clients.packages.geoRestrictions.edit', {
                                    id: clientId,
                                    packagesId: clientPackageId,
                                    geoRestrictionId: convertToInt(row.id),
                                }));
                            }}
                            tooltip={'General information'}
                            popupProps={{position: 'top right'}}
                        />
                        <IconWithTooltip
                            iconProps={{
                                size: 'large',
                                className: '--withPointer',
                                corner: 'top right',
                            }}
                            name='globe'
                            onClick={() => {
                                history.push(getLink('clients.packages.geoRestrictions.editGeoRestrictions', {
                                    id: clientId,
                                    packagesId: clientPackageId,
                                    geoRestrictionId: convertToInt(row.id),
                                }));
                            }}
                            tooltip={'Geo restrictions'}
                            popupProps={{position: 'top right'}}
                        />
                    </div>
                </Authorization>
            );
        }
        default: {
            return null;
        }
    }
};
